// Safari, and every iOS browser since they all use WebKit
export function isSafari() {
	var ua = navigator.userAgent;
	return /AppleWebKit/.test(ua) && !/Chrome|Chromium|Edg|OPR|Android/.test(ua);
}

// Monitoring tools that don't work in Safari (Web Audio and frame analysis of the stream)
export const SAFARI_UNSUPPORTED_TOOLS = ["frame_monitor", "audio_meters", "lufs"];

export const SAFARI_UNSUPPORTED_TEXT = "Not available in Safari. Use Chrome or Edge.";

export function toolSupported(tool) {
	return !(isSafari() && SAFARI_UNSUPPORTED_TOOLS.includes(tool));
}
